import { tracking } from '@iwoca/frontend-tracking-library';

import { TDocuments } from '../../../api/lendingApi/lendingApiQueries';
import { TOfferDataRequirement } from '../../../types';

type TAmplitudeDocRequirementStatusEventProperties = Omit<
  Parameters<typeof tracking.ampli.tradingHistoryViewed>[0],
  'Page version' | 'Requested product type' | 'requested_amount'
>;

export const amplitudeDocRequirementStatusEventProperties = (
  docRequirements: TOfferDataRequirement['actions'],
): TAmplitudeDocRequirementStatusEventProperties => {
  const getStatusFromRequirementType = (type: TDocuments['type']) => {
    const docRequirementOfType = docRequirements.find((requirement) => {
      return requirement.type === type;
    });

    if (!docRequirementOfType) return 'Not required';

    if (docRequirementOfType?.is_optional === true) return 'Optional';

    if (docRequirementOfType?.is_optional === false) return 'Required';

    return 'Not required';
  };

  return {
    'Aged debtor report required':
      getStatusFromRequirementType('aged_debtor_report'),
    'Business plan required': getStatusFromRequirementType('business_plan'),
    'Company accounts required':
      getStatusFromRequirementType('company_accounts'),
    'Management accounts required': getStatusFromRequirementType(
      'management_accounts',
    ),
    'Bank statements required': getStatusFromRequirementType('bank_statement'),
    'VAT returns required': getStatusFromRequirementType('vat_return'),
  };
};
